var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:'active-filter-item',attrs:{"data-preload":[_vm.$options.name]},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.label)+": "),_c('strong',[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),_c('Icon',{class:['icon-close'],attrs:{"name":"close"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }